export default class extends HTMLElement {
  connectedCallback () {
    const form = this.querySelector('form')
    if (!form) return
    form.addEventListener('submit', () => {
      window.app_tour.start()
    })
  }
}
